import {
  BorrowerContractLoanData,
  BorrowerUserDetails,
  Invitation,
  Loan,
  OnboardingDetailsType,
} from '@nemuru-eng/js-api-client';

import { removeNullKeysFromObject } from '../removeNullKeysFromObject';

export const patchUpdateBorrowerContractMapper = ({
  currentLoan,
  userDetails,
  borrowerInvitation,
  currentParticipantId,
  currentOnboardingDetails,
}: {
  currentLoan: Loan;
  userDetails: BorrowerUserDetails;
  borrowerInvitation: Invitation;
  currentParticipantId: string;
  currentOnboardingDetails;
}) => {
  if (currentOnboardingDetails && currentOnboardingDetails.type === OnboardingDetailsType.BORROWER && currentLoan) {
    const newUserDetails = { ...currentOnboardingDetails?.userDetails, ...userDetails };
    const selfEmploymentNetIncome = newUserDetails.professionalDetails?.selfEmploymentNetIncome;

    const mappedPatchUpdateBorrowerContractPayload: BorrowerContractLoanData = {
      loanId: currentLoan.id,
      borrowerId: currentParticipantId,
      borrowerEmail: borrowerInvitation ? borrowerInvitation.email : currentOnboardingDetails.invitation.email,
      borrowerPhone: borrowerInvitation
        ? borrowerInvitation.phoneNumber
        : currentOnboardingDetails.invitation.phoneNumber,
      borrowerIban: currentLoan?.borrowerCashInCashOutMethodAccountNumber || undefined,
      jobDescription: currentLoan?.assetDetails.jobDescription,
      userDetails: {
        ...(newUserDetails.documentId && {
          documentId: {
            documentType: newUserDetails.documentId.documentType,
            documentExpeditor: newUserDetails.documentId.documentExpeditor,
            fullNameFirstName: newUserDetails.documentId.fullName.firstName,
            fullNameLastName: newUserDetails.documentId.fullName.lastName,
            gender: newUserDetails.documentId.gender,
            nationality: newUserDetails.documentId.nationality,
            birthDate: newUserDetails.documentId.birthDate,
            birthPlaceAddress: newUserDetails.documentId.birthPlace,
            expiration: newUserDetails.documentId.expiration,
            documentNumber: newUserDetails.documentId.documentNumber,
            address: newUserDetails.documentId.documentAddress,
          },
        }),
        familiarSituationDetails: newUserDetails.familiarSituationDetails
          ? {
              maritalStatus: newUserDetails.familiarSituationDetails.maritalSituation.maritalStatus,
              maritalRegime: newUserDetails.familiarSituationDetails.maritalSituation.maritalRegime,
              childSupportNumber: newUserDetails.familiarSituationDetails.childSupportNumber,
            }
          : null,
        mainResidenceDetails: newUserDetails.mainResidenceDetails
          ? {
              ownershipType: newUserDetails.mainResidenceDetails.ownershipDetails.ownershipType,
              homeExpenses: {
                amount: newUserDetails.mainResidenceDetails.homeExpenses.amount,
                currency: newUserDetails.mainResidenceDetails.homeExpenses.currency,
              },
              address: newUserDetails.mainResidenceDetails.address,
              mortgage: newUserDetails.mainResidenceDetails.ownershipDetails.mortgage,
              entranceDate: newUserDetails.mainResidenceDetails.entranceDate,
              propertyType: newUserDetails.mainResidenceDetails.ownershipDetails.propertyType,
            }
          : null,
        professionalDetails: newUserDetails.professionalDetails
          ? {
              employmentStatus: newUserDetails.professionalDetails.employmentStatus,
              position: newUserDetails.professionalDetails.professionalPosition,
              companyActivity: newUserDetails.professionalDetails.companyInfo?.activity,
              companyName: newUserDetails.professionalDetails.companyInfo?.name,
              companyCity: newUserDetails.professionalDetails.companyInfo?.city,
              companySeniorityYears: newUserDetails.professionalDetails.companyInfo?.seniorityYears,
              companySeniorityMonths: newUserDetails.professionalDetails.companyInfo?.seniorityMonths,
              companyContractDateEnd: newUserDetails.professionalDetails.companyInfo?.companyContractDateEnd,
              corporateIdNumber: newUserDetails.professionalDetails.companyInfo?.corporateIdNumber || null,
              ...(selfEmploymentNetIncome?.value?.amount && selfEmploymentNetIncome.date
                ? {
                    selfEmploymentNetIncome: {
                      value: {
                        amount: Number(selfEmploymentNetIncome.value.amount),
                        currency: currentLoan.loanConditions.currency,
                      },
                      date: `${new Date(selfEmploymentNetIncome.date).getFullYear()}-12-31T00:00:00+00:00`,
                    },
                  }
                : {}),
            }
          : null,
      },
    };

    const removedNullKeysFromPatchPayload = removeNullKeysFromObject(mappedPatchUpdateBorrowerContractPayload);

    return removedNullKeysFromPatchPayload;
  }
};
